interface MasterKaizenHintProps {
  hint: string;
  show: boolean;
}

/**
 * Master Kaizen Sensei inline hint component
 * Replaces the yellow lightbulb hint boxes with themed sensei wisdom
 */
export default function MasterKaizenHint({ hint, show }: MasterKaizenHintProps) {
  if (!show) return null;

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border-2 border-blue-300 dark:border-blue-600 rounded-lg p-4 mb-4">
      <div className="flex items-start gap-3">
        <span className="text-xl flex-shrink-0" aria-hidden="true">
          🥋
        </span>
        <div>
          <p className="font-semibold text-blue-900 dark:text-blue-100 mb-2">
            Sensei's Wisdom:
          </p>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            {hint}
          </p>
        </div>
      </div>
    </div>
  );
}
